export const SasiType = {
    NAMI: 0,
    HIRAKI: 1,
}

export const NeedleMode = {
    SINGLE: 0,
    MULTIPLE: 1,
}

export interface Ito {
    rounds: number,
    color: string, // i.g. '99ff00', 'gray'
};

export interface Procedure {
    groupNo: number,
    matomeSasi: boolean,
    sasiType: number,
    connectedRounds: number,
    offset: number,
    itos: Array<Ito>,
};

export interface Yubinuki {
    koma: number,
    tobi: number,
    resolutionAuto: boolean,
    resolution: number,
    needleMode: number,
    procedures: Array<Procedure>,
};
